import React from 'react';
import ApplicationShell from './ApplicationShell';

interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  breadcrumbs?: Array<{ label: string; href?: string }>;
  onPageChange: (page: string) => void;
  onRefresh?: () => void;
  notifications?: number;
  user?: {
    name: string;
    email: string;
    avatar?: string;
    role: string;
  };
}

const Layout: React.FC<LayoutProps> = ({
  children,
  currentPage,
  breadcrumbs = [],
  onPageChange,
  onRefresh,
  notifications = 0,
  user = {
    name: 'Admin User',
    email: 'admin@neobridge.com',
    role: 'Administrator'
  }
}) => {
  // Generate breadcrumbs based on current page
  const getBreadcrumbs = () => {
    const pageBreadcrumbs = [
      { label: 'Dashboard', href: 'dashboard' }
    ];

    switch (currentPage) {
      case 'payments':
        pageBreadcrumbs.push({ label: 'Payments', href: 'payments' });
        break;
      case 'users':
        pageBreadcrumbs.push({ label: 'Users', href: 'users' });
        break;
      case 'compliance':
        pageBreadcrumbs.push({ label: 'Compliance', href: 'compliance' });
        break;
      case 'analytics':
        pageBreadcrumbs.push({ label: 'Analytics', href: 'analytics' });
        break;
      case 'monitoring':
        pageBreadcrumbs.push({ label: 'Monitoring', href: 'monitoring' });
        break;
      case 'blockchain':
        pageBreadcrumbs.push({ label: 'Blockchain', href: 'blockchain' });
        break;
      case 'settings':
        pageBreadcrumbs.push({ label: 'Settings', href: 'settings' });
        break;
      default:
        pageBreadcrumbs.push({ label: 'Dashboard', href: 'dashboard' });
    }

    return pageBreadcrumbs;
  };

  return (
    <ApplicationShell
      currentPage={currentPage}
      breadcrumbs={breadcrumbs.length > 0 ? breadcrumbs : getBreadcrumbs()}
      onPageChange={onPageChange}
      onRefresh={onRefresh}
      notifications={notifications}
      user={user}
    >
      {children}
    </ApplicationShell>
  );
};

export default Layout;
